import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reset } from 'redux-form';
import { Modal } from 'react-bootstrap';
import { Button, AsyncButton, EmailInput } from '@jauntin/react-ui';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { reduxForm, Field } from 'redux-form';
import PriceService from '../../Helpers/PriceService';
import API from '../../Helpers/API';
import { saveQuoteFormName } from '../../Constants/constants';
import { getSaveQuotePayload } from '../../Selectors/SavingQuote';
import { Alert } from 'react-bootstrap';
import { validators, normalizers } from '@jauntin/utilities';
const { required, email } = validators;
const { normalizeEmail } = normalizers;

const ModalSaveQuote = ({ show, handleClose, pristine, invalid }) => {
  const dispatch = useDispatch();
  const data = useSelector(getSaveQuotePayload);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(false);

  const submitForm = async (data) => {
    setSubmitting(true);
    try {
      await new PriceService(new API()).saveQuote(data);
      setSubmitting(false);
      setSubmitted(true);
      setApiError(false);
    } catch (e) {
      setApiError(true);
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (show) {
      dispatch(reset(saveQuoteFormName));
      setSubmitted(false);
    }
  }, [show, dispatch]);

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      {submitted ? (
        <>
          <Modal.Body className="pb-4">
            <Modal.Header className="w-100 border-0 pb-0" />
            <div className="mt-4 text-center">
              A link for the quote has been sent to your email.
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4">
            <Button
              className="btn-primary"
              type="button"
              onClick={handleClose}
              text="Done"
            />
          </Modal.Footer>
        </>
      ) : (
        <>
          <Modal.Body className="pb-4">
            <Modal.Header className="w-100 border-0 pb-0" />
            <div className="mt-4">
              A link for the quote will be sent to your email.
            </div>
            <Field
              name="email"
              component={EmailInput}
              validate={[required, email]}
              normalize={normalizeEmail}
              inputClassName="form-control-lg"
              className="mb-0"
            />
            {apiError && (
              <Alert variant="error" className="mt-3">
                <i className="far fa-exclamation-circle alert__icon" />
                <div className="alert__text">
                  Sorry, we were unable to process your request. Please try
                  again or contact us at{' '}
                  <span className="text-nowrap">(844) 747-6240</span> or
                  gatherguard@intactinsurance.com for further assistance.{' '}
                </div>
              </Alert>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4">
            <Button
              onClick={handleClose}
              className="btn btn-outline-primary"
              text="Cancel"
            />
            <AsyncButton
              onClick={() => {
                submitForm(data);
              }}
              spinning={submitting}
              disabled={pristine || invalid || submitting}
              className="btn btn-primary d-flex"
            >
              Save Quote
            </AsyncButton>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

ModalSaveQuote.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};

ModalSaveQuote.defaultProps = {
  show: false,
};

export default compose(reduxForm({ form: saveQuoteFormName }))(ModalSaveQuote);
